import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">用户热评</h2>
          <p className="text-sm md:text-base text-foreground-400">来看看其他吃瓜群众都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-950 truncate">{comment.name}</h3>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}